function initCartRecommendations(scope = document) {

  scope.querySelectorAll('.cart-recommendations').forEach((container)=>{

    if(container.dataset.sliderReady) return;

    const slider = container.querySelector('.cart-recommendations-slider');

    if(!slider) return;


    let originalSlides = [
      ...slider.querySelectorAll('.cart-recommendation-slide')
    ];


    if(originalSlides.length <= 1) return;



    // Clones
    const firstClone = originalSlides[0].cloneNode(true);
    const lastClone = originalSlides[originalSlides.length - 1].cloneNode(true);


    slider.appendChild(firstClone);
    slider.insertBefore(lastClone, originalSlides[0]);



    let slides = [
      ...slider.querySelectorAll('.cart-recommendation-slide')
    ];


    let index = 1;
    let isResetting = false;



    function getWidth(){
      return slides[0].offsetWidth;
    }



    function goTo(position, smooth = true){

      slider.scrollTo({
        left: position * getWidth(),
        behavior: smooth ? 'smooth' : 'auto'
      });

    }



    // posición inicial
    requestAnimationFrame(()=>{
      goTo(index,false);
    });



    container.addEventListener('click',(e)=>{


      const next = e.target.closest(
        '.cart-recommendations-arrow--next'
      );


      const prev = e.target.closest(
        '.cart-recommendations-arrow--prev'
      );



      if(next){

        index++;

        goTo(index);

      }



      if(prev){

        index--;

        goTo(index);

      }


    });





    slider.addEventListener('scroll',()=>{


      if(isResetting) return;



      const current = Math.round(
        slider.scrollLeft / getWidth()
      );



      // Llegamos al clon final
      if(current === slides.length - 1){


        isResetting = true;


        setTimeout(()=>{


          slider.style.scrollBehavior = 'auto';


          index = 1;


          slider.scrollLeft = getWidth() * index;



          slider.style.scrollBehavior = '';


          isResetting = false;


        },300);


        return;

      }




      // Llegamos al clon inicial
      if(current === 0){


        isResetting = true;


        setTimeout(()=>{


          slider.style.scrollBehavior = 'auto';


          index = slides.length - 2;


          slider.scrollLeft =
            getWidth() * index;



          slider.style.scrollBehavior = '';



          isResetting = false;



        },300);


        return;

      }



      index=current;


    });



    container.dataset.sliderReady="true";


  });

}

const observer = new MutationObserver(() => {
  setTimeout(() => {
    initCartRecommendations(document);
  }, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener('DOMContentLoaded', () => {
  initCartRecommendations();
});

function getQuickAddElements() {
  return {
    quickAdd: document.querySelector('.cart-quick-add'),
    quickAddContent: document.querySelector('#cart-quick-add-content'),
    quickAddClose: document.querySelector('.cart-quick-add__close'),
    quickAddOverlay: document.querySelector('.cart-quick-add__overlay'),
  };
}

function closeQuickAdd() {
  const { quickAdd, quickAddContent } = getQuickAddElements();

  if (!quickAdd) return;

  quickAdd.hidden = true;
  quickAddContent.innerHTML = '';
}

function convertVariantButtonsToDropdowns(container) {
  container.querySelectorAll('.variant-option--buttons').forEach((fieldset) => {
    if (fieldset.querySelector('.variant-option__select')) return;

    const radios = [...fieldset.querySelectorAll('input[type="radio"]')];
    if (!radios.length) return;

    const select = document.createElement('select');
    select.className = 'variant-option__select';

    radios.forEach((radio) => {
      radio.hidden = true;

      const option = document.createElement('option');
      option.value = radio.value;
      option.textContent = radio.value;
      option.dataset.optionValueId = radio.dataset.optionValueId;

      if (radio.checked) {
        option.selected = true;
          option.setAttribute('selected', 'selected');
      }

      select.appendChild(option);
    });

    select.addEventListener('change', () => {
      const option = select.selectedOptions[0];

      const radio = radios.find(
        (r) => r.dataset.optionValueId === option.dataset.optionValueId
      );

      if (!radio) return;

      radio.checked = true;

      radio.dispatchEvent(
        new Event('change', {
          bubbles: true,
        })
      );
    });

    fieldset.appendChild(select);
  });
}

function convertSingleVariantToDropdown(container) {
  container
    .querySelectorAll('[data-testid="variant-option-single"]')
    .forEach((option) => {
      if (option.querySelector('select')) return;

      const value = option.querySelector('.variant-option__swatch-value');
      if (!value) return;

      const label = option.childNodes[0]?.textContent.trim() || '';

      const select = document.createElement('select');
      select.className = 'variant-option__select';

      const opt = document.createElement('option');
      opt.value = value.textContent.trim();
      opt.textContent = value.textContent.trim();

      select.appendChild(opt);

      option.innerHTML = '';

      if (label) {
        const labelNode = document.createElement('label');
        labelNode.textContent = label;
        option.appendChild(labelNode);
      }

      option.appendChild(select);
    });
}

function observeVariantPicker(container) {
  const picker = container.querySelector('variant-picker');

  if (!picker) return;

  const observer = new MutationObserver(() => {
    convertVariantButtonsToDropdowns(container);
    convertSingleVariantToDropdown(container);
  });

  observer.observe(picker, {
    childList: true,
    subtree: true,
  });
}

async function openQuickAdd(button) {
  const { quickAdd, quickAddContent } = getQuickAddElements();

  if (!quickAdd || !quickAddContent) {
    console.error('No existe cart quick add');
    return;
  }

  const recommendationCard = button.closest('.cart-recommendation-product');
  const url = new URL(button.dataset.productUrl, window.location.origin);
  
  url.searchParams.set('cart_quick_add', 'true');

const response = await fetch(url);
const html = await response.text();

console.log(html.substring(0,1000));

const doc = new DOMParser().parseFromString(html, 'text/html');
console.log(
  [...doc.querySelectorAll('script[type="application/json"]')]
  .map((script, i) => ({
    index: i,
    id: script.id,
    class: script.className,
    content: script.textContent.substring(0, 200)
  }))
);

// Buscamos el product-form completo
const productInfo = doc.querySelector('product-info');

if (!productInfo) {
  console.error('No existe product-info');
  return;
}

const clonedProductInfo = productInfo.cloneNode(true);

const productJSON = doc.querySelector(
  'script[type="application/json"][data-product-json]'
);

let variantsData = [];

const productJsonUrl = `${button.dataset.productUrl}.js`;

const productResponse = await fetch(productJsonUrl);

const productData = await productResponse.json();

variantsData = productData.variants || [];

console.log('Variantes reales:', variantsData);

// Limpiamos el contenido anterior del quick add
quickAddContent.innerHTML = '';


// Agregamos la tarjeta original del producto recomendado
if (recommendationCard) {

  const clone = recommendationCard.cloneNode(true);

  const oldButton = clone.querySelector('.cart-recommendation-add');

  if (oldButton) {
    oldButton.remove();
  }

  quickAddContent.appendChild(clone);
}

// Clonamos TODO el formulario
const clonedForm = clonedProductInfo.querySelector('product-form');
const newProductContent = document.createElement('div');
newProductContent.className = 'quick-add-product-info';
newProductContent.style.marginTop = '15px';

// Buscamos el selector de variantes dentro del formulario
const clonedVariants = clonedProductInfo.querySelector(
  'variant-selects, variant-radios'
);



// Convertimos radios a selects manteniendo la lógica Shopify
if (clonedVariants) {

  const fieldsets = clonedVariants.querySelectorAll('fieldset');


  fieldsets.forEach(fieldset => {

    // Evitar duplicados
    if (fieldset.querySelector('.quick-add-variant-select')) {
      return;
    }


    const radios = [
      ...fieldset.querySelectorAll('input[type="radio"]')
    ];


    if (!radios.length) return;


    // Ocultamos los radios originales
    fieldset.style.display = 'none';


    // Crear label
    const legend = fieldset.querySelector('legend');

    if (legend) {

      const label = document.createElement('label');

      label.textContent =
        legend.textContent.trim();

      label.style.display = 'block';
      label.style.fontWeight = 'bold';
      label.style.marginBottom = '5px';

      fieldset.parentNode.insertBefore(
        label,
        fieldset
      );
    }



    // Crear select
    const select = document.createElement('select');

    select.className =
      'quick-add-variant-select';


    select.style.width = '100%';
    select.style.padding = '10px';
    select.style.marginBottom = '15px';
    select.style.borderRadius = '5px';
    select.style.border = '1px solid #ccc';



    radios.forEach(radio => {

      const option =
        document.createElement('option');


      option.value = radio.value;
      option.textContent = radio.value;


      if (radio.checked) {
        option.selected = true;
      }


      select.appendChild(option);

    });



   select.addEventListener('change', () => {


  const selected =
    radios.find(
      radio =>
        radio.value === select.value
    );


  if (!selected) return;


  selected.checked = true;


  selected.dispatchEvent(
    new Event(
      'change',
      {
        bubbles:true
      }
    )
  );


  // Buscar variante seleccionada
  setTimeout(() => {


    const selectedOptions = [];


    clonedVariants
      .querySelectorAll('input[type="radio"]:checked')
      .forEach(input => {
        selectedOptions.push(input.value);
      });


    console.log(
      'Opciones seleccionadas:',
      selectedOptions
    );


const variant = variantsData.find(v => {

  const options = [
    v.option1,
    v.option2,
    v.option3
  ].filter(Boolean);


  return selectedOptions.every(option =>
    options.includes(option)
  );

});


console.log(
  'Variante encontrada:',
  variant
);





    if (!variant) return;


    // Actualizar variante que enviará el formulario
const variantInput = quickAddContent.querySelector(
  'input[name="id"]'
);

if (variantInput) {
  variantInput.value = variant.id;

  variantInput.dispatchEvent(
    new Event('change', {
      bubbles:true
    })
  );

  console.log(
    'ID variante actualizado:',
    variant.id
  );
}

if (!variant || !variant.featured_image) {
  console.log('La variante no tiene imagen');
  return;
}



    const modalImage =
      quickAddContent.querySelector(
        '.cart-recommendation-product img'
      );


    if (!modalImage) {
      console.log(
        'No encontré imagen del quick add'
      );
      return;
    }



    modalImage.src =
      variant.featured_image.src;


    modalImage.srcset =
      variant.featured_image.src;


    console.log(
      'Imagen actualizada:',
      variant.featured_image.src
    );


  }, 300);


});



    fieldset.parentNode.insertBefore(
      select,
      fieldset
    );


  });


}



// Ocultar cantidad
const quantityInput =
  clonedForm.querySelector(
    '.quantity, quantity-input'
  );


if (quantityInput) {
  quantityInput.style.display = 'none';
}



// Botón ancho completo
const btn =
  clonedForm.querySelector('button');


if (btn) {

  btn.style.width = '100%';
  btn.style.marginTop = '10px';

}



// Agregamos TODO dentro del modal
// Agregar únicamente selector de variantes
if (clonedVariants) {
  newProductContent.appendChild(clonedVariants);
}


// Agregar únicamente formulario
if (clonedForm) {
  newProductContent.appendChild(clonedForm);
}

  // 3. Inyectamos todo al modal
  quickAddContent.appendChild(newProductContent);

  convertVariantButtonsToDropdowns(quickAddContent);
  convertSingleVariantToDropdown(quickAddContent);
  observeVariantPicker(quickAddContent);

  quickAdd.hidden = false;
  
const quickForm = quickAddContent.querySelector(
  'form[data-type="add-to-cart-form"]'
);

const engravingInput = quickAddContent.querySelector(
  '[name="properties[Nombre del niño]"]'
);

const engravingError = quickAddContent.querySelector(
  '#custom-input-error'
);

if (quickForm && engravingInput) {
  quickForm.addEventListener(
    'submit',
    function (e) {
      if (!engravingInput.value.trim()) {
        e.preventDefault();
        e.stopImmediatePropagation();

        if (engravingError) {
          engravingError.style.display = 'block';
        }

        engravingInput.style.border = '2px solid red';
        engravingInput.focus();

        return false;
      }

      if (engravingError) {
        engravingError.style.display = 'none';
      }

      engravingInput.style.border = '1px solid #ccc';
    },
    true
  );
}


  quickAddContent.addEventListener('submit', () => {
    setTimeout(() => {
      const error = quickAddContent.querySelector(
        '.product-form-text__error:not(.hidden)'
      );

      if (error) {
        console.log('Error de cantidad, mantener abierto');
        return;
      }

      closeQuickAdd();
    }, 800);
  });
}

document.addEventListener('click', (e) => {
  if (e.target.closest('.cart-quick-add__close')) {
    closeQuickAdd();
  }

  if (e.target.closest('.cart-quick-add__overlay')) {
    closeQuickAdd();
  }
});

document.addEventListener('click', async (e) => {
  const button = e.target.closest('.cart-recommendation-add');

  if (!button) return;

  if (button.dataset.hasVariants === 'true') {
    openQuickAdd(button);
    return;
  }

  // Deshabilitar botón para evitar doble clic y dar feedback visual
  button.disabled = true;
  const originalText = button.textContent;
  button.textContent = '...'; 

  try {
    // 1. Agregar el producto al backend
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: button.dataset.variantId,
            quantity: 1,
          },
        ],
      }),
    });

    const cart = await response.json();

    if (cart.item_count === 1 && window.startCartCountdown) {
  window.startCartCountdown();
}

    // 2. Pedirle a Shopify el HTML actualizado del carrito usando el nombre correcto de tu sección
    const sectionsResponse = await fetch('/?sections=cart-drawer');
    const sections = await sectionsResponse.json();
    const html = sections['cart-drawer'];
console.log(html.substring(0, 1000));
    if (html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      console.log(
    [...doc.querySelectorAll('script[type="application/json"]')]
        .map((s,i)=>({
            i,
            text:s.textContent.substring(0,150)
        }))
);

      // 3. Buscar el contenedor exacto de tu tema
      const newInner = doc.querySelector('.drawer__inner');
      const currentInner = document.querySelector('.drawer__inner');

      // 4. Reemplazar el viejo por el nuevo
      if (newInner && currentInner) {
        currentInner.replaceWith(newInner);

        setTimeout(() => {
          initCartRecommendations(document);
        }, 100);
      }
    }

    // 5. Avisarle al tema que el carrito se actualizó (para la burbuja del header, etc)
    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          action: 'add',
          cart: cart,
          itemCount: cart.items.length
        }
      })
    );
    
  } catch (error) {
    console.error('Error al agregar el producto:', error);
  }

  // Restaurar el botón
  button.textContent = originalText;
  button.disabled = false;
});